export default function LinksNav(currentPage = '') {
    const isActive = (href) => {
        // Remove .html extension for comparison
        const pagePath = href.replace('.html', '');
        
        // Extract just the filename from the currentPage pathname
        let currentPath = currentPage.split('/').pop().replace('.html', '');
        
        // Normalize root/empty path to 'index' for comparison
        if (!currentPath || currentPath === '') {
            currentPath = 'index';
        }
        
        return currentPath === pagePath ? 'active' : '';
    };

    return `
        <div>
            <div>
                <div class="nav__header">
                    <h1>Jackson Greenberg</h1>
                </div>


                <div class="complilation-links table-window" >
                    <table class="sheet-table">
                        <tr>
                            <td>
                                <a href="index.html" 
                                   class="${isActive('index.html')}" 
                                   hx-get="index.html" 
                                   hx-target="body" 
                                   hx-push-url="true"
                                   rel="noopener noreferrer">New Recording 21</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="three.html" 
                                   class="${isActive('three.html')}" 
                                   hx-get="three.html" 
                                   hx-target="body" 
                                   hx-push-url="true"
                                   rel="noopener noreferrer">The Latter Years E</a>
                            </td>
                        </tr>
                        
                        <tr>
                            <td>
                                <a href="four.html" 
                                   class="${isActive('four.html')}" 
                                   hx-get="four.html" 
                                   hx-target="body" 
                                   hx-push-url="true"
                                   rel="noopener noreferrer">The Game is Over v2.0</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="six.html" 
                                   class="${isActive('six.html')}" 
                                   hx-get="six.html" 
                                   hx-target="body" 
                                   hx-push-url="true"
                                   rel="noopener noreferrer">Fly Eagles Fly (Slowly)</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="seven.html" 
                                   class="${isActive('seven.html')}" 
                                   hx-get="seven.html" 
                                   hx-target="body" 
                                   hx-push-url="true"
                                   rel="noopener noreferrer">Spin to His Heart's Content</a>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <a href="eight.html" 
                                   class="${isActive('eight.html')}" 
                                   hx-get="eight.html" 
                                   hx-target="body" 
                                   hx-push-url="true"
                                   rel="noopener noreferrer">Embarkation</a>
                            </td>
                        </tr>
                    </table>
                </div>

                
                <div class="streaming-links table-window" id="table-container"></div>
                <div class="sheet-table" id="secondary-table-container"></div>
                <div class="sheet-table" id="news-table-container"></div>
                <div class="f33d__luc" id=""><a target="_blank" href="https://mikelsons.ca">Mikelsons.ca</a></div>    
            </div>
            
        </div>
    `;
} 